import { getLateSlabs, getEarlySlabs, SHIFT_META } from "@/lib/attendanceShifts";

const num = (v) => Math.round((Number(v) || 0) * 100) / 100;

const SHEETS = [
    { key: "corporate", name: "Corporate Shift" },
    { key: "firmware", name: "Firmware Shift" },
];

export async function exportAttendanceXlsx({ buckets, deptName, stats, monthLabel, fileName }) {
    const ExcelJS = (await import("exceljs")).default;
    const wb = new ExcelJS.Workbook();
    wb.creator = "Odyssey";
    wb.created = new Date();

    for (const { key, name } of SHEETS) {
        const rows = buckets[key] || [];
        if (!rows.length) continue;
        const meta = SHIFT_META[key];
        const ws = wb.addWorksheet(name, { views: [{ state: "frozen", ySplit: 1 }] });
        ws.columns = [
            { header: "Employee", key: "employee", width: 24 },
            { header: "Department", key: "department", width: 30 },
            { header: "Month", key: "month", width: 22 },
            ...meta.lateLabels.map((l, i) => ({ header: `Late ${l}`, key: `l${i}`, width: 16 })),
            ...meta.earlyLabels.map((l, i) => ({ header: `Early ${l}`, key: `e${i}`, width: 16 })),
            { header: "OFF", key: "oof", width: 8 },
            { header: "WFH", key: "wfh", width: 8 },
            { header: "Present %", key: "present", width: 11, style: { numFmt: "0%" } },
            { header: "In-Office %", key: "office", width: 12, style: { numFmt: "0%" } },
            { header: "Critical Instances", key: "critical", width: 17 },
            { header: "Total Instances", key: "total", width: 15 },
        ];
        for (const r of rows) {
            const l = getLateSlabs(r).map(num);
            const e = getEarlySlabs(r).map(num);
            const s = stats(r);
            ws.addRow({
                employee: r.employee_name || "",
                department: deptName(r),
                month: monthLabel(r),
                l0: l[0], l1: l[1], l2: l[2],
                e0: e[0], e1: e[1], e2: e[2],
                oof: num(r.oof),
                wfh: num(r.wfh),
                present: s.presentPct / 100,
                office: s.inOfficePct / 100,
                critical: num(l[2] + e[2]),
                total: num(l.reduce((a, b) => a + b, 0) + e.reduce((a, b) => a + b, 0)),
            });
        }
        const header = ws.getRow(1);
        header.height = 22;
        header.eachCell((c) => {
            c.font = { bold: true, color: { argb: "FFFFFFFF" } };
            c.fill = { type: "pattern", pattern: "solid", fgColor: { argb: "FF25908A" } };
            c.alignment = { vertical: "middle", horizontal: "center" };
        });
        ws.autoFilter = { from: { row: 1, column: 1 }, to: { row: 1, column: ws.columns.length } };
    }

    if (!wb.worksheets.length) return false;
    const buf = await wb.xlsx.writeBuffer();
    const url = URL.createObjectURL(new Blob([buf], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" }));
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    a.click();
    URL.revokeObjectURL(url);
    return true;
}
